// extracted by mini-css-extract-plugin
export default {"statBoxLight":"StatsGrid_light_statBoxLight__wYR5Z","progressBarLight":"StatsGrid_light_progressBarLight__Z76y2","progressFillLight":"StatsGrid_light_progressFillLight__7LbVA"};